(function () {
  class SideMenu extends PIXI.Container {
    constructor(screenMaskId, closeButtonId) {
      super();

      this._screenMaskId = screenMaskId;
      this._closeButtonId = closeButtonId;

      this._settingsOpen = false;

      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
      messageBus.subscribe("game:sideMenuOpen", this.onSideMenuOpen.bind(this));
      messageBus.subscribe(
        "game:sideMenuClosed",
        this.onSideMenuClosed.bind(this)
      );
      messageBus.subscribe("ui:modal", this.onUIModal.bind(this));
      messageBus.subscribe("game:modal", this.onModal.bind(this));

      this.visible = false;
    }

    initialise() {
      this._dimScreen = resourceManager.get(this._screenMaskId);
      this._closeButton = resourceManager.get(this._closeButtonId);

      this._background = resourceManager.get("overSlotContainerMaskDimObject");

      resourceManager.get(
        "sideMenu:sideMenuPanel:sideMenuBtnContainer:history"
      ).visible = this._activeButtons.btnHistory.visible;
      resourceManager.get(
        "sideMenu:sideMenuPanel:sideMenuBtnContainer:options"
      ).visible = this._activeButtons.btnInfo.visible;
      resourceManager.get(
        "sideMenu:sideMenuPanel:sideMenuBtnContainer:settingsMenu"
      ).visible = this._activeButtons.btnSettings.visible;
      resourceManager.get(
        "sideMenu:sideMenuPanel:sideMenuBtnContainer:gameRules"
      ).visible = this._activeButtons.btnRules.visible;

      this._closeButton.mousedown = this._closeButton.touchstart = function () {
        messageBus.postImmediate("game:sideMenuClosed", {});
        messageBus.postImmediate("game:settingMenuClosed", {});
      };

      this._background.mousedown = this._background.touchstart = function () {
        messageBus.postImmediate("game:sideMenuClosed", {});
        messageBus.postImmediate("game:settingMenuClosed", {});
      };
    }

    onGameConfigEvent(config) {
      this._activeButtons = config.data.uiElements;
      const canEnableSound = this._activeButtons.btnSound.visible;
      if (!canEnableSound) {
        this._activeButtons.btnSettings.enabled = false;
        this._activeButtons.btnSettings.visible = false;
      }

      this.hideDisabledButtonsAndReposition();

      resourceManager.get(
        "sideMenu:sideMenuPanel:sideMenuBtnContainer:history:highlight"
      ).visible = false;

      this.initialise();
    }

    hideDisabledButtonsAndReposition() {
      const sideMenuButtons = [
        { name: "btnHome", id: "home" },
        { name: "btnHistory", id: "history" },
        { name: "btnSettings", id: "settingsMenu" },
        { name: "btnRules", id: "gameRules" },
        { name: "btnInfo", id: "options" },
        { name: "btnFullscreen", id: "fullscreenButton" },
      ];

      const numOfButtonsHidden = sideMenuButtons.filter(
        ({ name, id }) =>
          !(
            this._activeButtons[name] === true ||
            this._activeButtons[name].enabled
          )
      ).length;
      let bgYPosAndScale = { scale: 1, pos: 0 };
      switch (numOfButtonsHidden) {
        case 5:
          bgYPosAndScale = { scale: 0.21, pos: 226 };
          break;
        case 4:
          bgYPosAndScale = { scale: 0.37, pos: 180 };
          break;
        case 3:
          bgYPosAndScale = { scale: 0.53, pos: 137 };
          break;
        case 2:
          bgYPosAndScale = { scale: 0.69, pos: 90 };
          break;
        case 1:
          bgYPosAndScale = { scale: 0.85, pos: 47 };
          break;
        case 0:
        default:
          break;
      }

      const buttonSpacing = 92;
      let currentY = 250;

      if (
        numOfButtonsHidden > 0 &&
        numOfButtonsHidden !== sideMenuButtons.length
      ) {
        sideMenuButtons.forEach(({ name, id }) => {
          if (
            this._activeButtons[name] === true ||
            this._activeButtons[name].enabled
          ) {
            const button = resourceManager.get(
              `sideMenu:sideMenuPanel:sideMenuBtnContainer:${id}`
            );
            button.y = currentY;
            currentY -= buttonSpacing;
          }
        });
        const bg = resourceManager.get("sideMenu:sideMenuPanel:bg");
        bg.scale.set(1, bgYPosAndScale.scale);
        bg.y = bgYPosAndScale.pos;
        resourceManager.get(
          "sideMenu:sideMenuPanel:sideMenuBtnContainer:closeButton"
        ).y = currentY + 32;
      }
    }

    onSideMenuOpen() {
      if (this._dimScreen !== undefined) {
        this._dimScreen.show(true, 1);
      }
      this._closeButton.interactive = true;
      this.visible = true;
      messageBus.post("game:modal", { reason: "Side Menu Open" });
    }

    onSideMenuClosed() {
      if (this._dimScreen !== undefined) {
        this._dimScreen.show(false);
      }
      soundManager.play("buyBonusCancel");
      this._closeButton.interactive = false;
      this.visible = false;
      messageBus.post("game:modal", {});
    }

    onUIModal(event) {
      switch (event.reason) {
        case "History open": {
          resourceManager.get(
            "sideMenu:sideMenuPanel:sideMenuBtnContainer:history:highlight"
          ).visible = true;
          this._settingsOpen = true;
          break;
        }
      }
    }

    onModal(event) {
      if (event.reason === undefined || event.reason === "") {
        // activating golden bet forces us out of modal on the stake change - catch this here
        // if the settings dialog is open - not post is used here to ensure this is actioned in the correct order
        if (resourceManager.get("settingsMenu").visible) {
          messageBus.post("game:modal", { reason: "Settings menu open" });
        } else if (this._settingsOpen) {
          this._settingsOpen = false;
          resourceManager.get(
            "sideMenu:sideMenuPanel:sideMenuBtnContainer:history:highlight"
          ).visible = false;
          messageBus.postImmediate("game:sideMenuClosed", {});
        }
      }
    }
  }

  var sideMenuCreator = function (json) {
    return new SideMenu(json.screenMaskId, json.closeButtonId);
  };

  var sideMenuInitialiser = function (json) {};

  var sideMenuFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "sideMenu",
    sideMenuCreator,
    sideMenuInitialiser,
    sideMenuFilesRequired
  );
})();
